export enum InteractionType {
	Phone = 0,
	Email = 10,
	FaceToFaceMeeting = 20,
	VirtualMeeting = 30,
	Linkedin = 40,
}